import { appeler } from './api.js';

export interface DemandeCreationClient {
  readonly code: string;
  readonly nom: string;
  readonly courrielProprietaire: string;
  readonly nomProprietaire?: string | undefined;
}

/**
 * Le secret n est present QUE si le compte proprietaire vient d etre cree,
 * et il n est rendu qu UNE fois [28-BT] : aucune route ne le relit. La forme
 * du type l impose -- la branche « existant » n en porte pas.
 */
export type ResultatCreationClient =
  | { readonly locataire: VueLocataire; readonly proprietaire: 'existant' }
  | { readonly locataire: VueLocataire; readonly proprietaire: 'cree';
      readonly accesInitial: { readonly secret: string } };

export interface VueLocataire {
  readonly id: string; readonly idPublic: string;
  readonly code: string; readonly nom: string;
}

/**
 * LES CINQ GESTES D ETAT DU COCKPIT [29-I].
 *
 * ECRITURE PAR FACADE, lecture par hook : les deux inventaires restent dans
 * leurs ecrans, avec leur chemin inline et leur curseur.
 *
 * ╔═══════════════════════════════════════════════════════════════════════╗
 * ║ CINQ GESTES, CINQ APPELS. Pas de fonction generique a parametre.      ║
 * ╚═══════════════════════════════════════════════════════════════════════╝
 *
 * `archive` n est pas une valeur de `etat` : suspendre ecrit `etat`, archiver
 * ecrit `archive_le`, et l archivage est TERMINAL. Une facade generique
 * mentirait sur le modele -- comme le ferait un PUT /etat cote serveur.
 *
 * AUCUN CORPS : l intention est dans la methode et le chemin. Le serveur ne
 * lit rien d autre.
 *
 * L API DIT `clients`, ET L INTERFACE AUSSI ICI. La regle « l API dit
 * locataires, l interface dit espaces » vaut pour le monde LOCATAIRE ; le
 * monde plateforme n a jamais parle d espaces.
 */
export async function suspendreClient(idClient: string): Promise<void> {
  await appeler('PUT', `/plateforme/clients/${encodeURIComponent(idClient)}/suspension`);
}

export async function reactiverClient(idClient: string): Promise<void> {
  await appeler('DELETE', `/plateforme/clients/${encodeURIComponent(idClient)}/suspension`);
}

export async function suspendreProjetClient(
  idClient: string, idProjet: string,
): Promise<void> {
  await appeler('PUT', `/plateforme/clients/${encodeURIComponent(idClient)}`
    + `/projets/${encodeURIComponent(idProjet)}/suspension`);
}

export async function reactiverProjetClient(
  idClient: string, idProjet: string,
): Promise<void> {
  await appeler('DELETE', `/plateforme/clients/${encodeURIComponent(idClient)}`
    + `/projets/${encodeURIComponent(idProjet)}/suspension`);
}

/** TERMINAL : aucun geste ne defait un archivage. L ecran confirme avant. */
export async function archiverProjetClient(
  idClient: string, idProjet: string,
): Promise<void> {
  await appeler('PUT', `/plateforme/clients/${encodeURIComponent(idClient)}`
    + `/projets/${encodeURIComponent(idProjet)}/archivage`);
}

export async function creerClient(
  d: DemandeCreationClient,
): Promise<ResultatCreationClient> {
  return appeler<ResultatCreationClient>('POST', '/plateforme/clients', d);
}
